/** Logical actions, independent of the physical key that triggers them. */
export type Action =
  | 'moveForward'
  | 'moveBack'
  | 'moveLeft'
  | 'moveRight'
  | 'jump'
  | 'crouch'
  | 'sneak'
  | 'grab'
  | 'fire'
  | 'grapple'
  | 'melee'
  | 'switchWeapon'
  | 'toggleCamera'
  | 'toggleHeadTracking'
  | 'swivelView'
  | 'buildNext'
  | 'buildVariant'
  | 'buildRotate'
  | 'buildDelete'
  | 'buildMagnetic'
  | 'buildDrone'
  | 'buildWaypoint'
  | 'pause'
  | 'restart'
  | 'debug';

export const DEFAULT_BINDINGS: Record<Action, string[]> = {
  moveForward: ['KeyW', 'ArrowUp'],
  moveBack: ['KeyS', 'ArrowDown'],
  moveLeft: ['KeyA', 'ArrowLeft'],
  moveRight: ['KeyD', 'ArrowRight'],
  jump: ['Space'],
  crouch: ['ControlLeft', 'KeyC'],
  sneak: ['ShiftLeft', 'ShiftRight'],
  grab: ['KeyE'],
  fire: ['Mouse0'],
  grapple: ['Mouse2'],
  melee: ['KeyF'],
  switchWeapon: ['KeyT'],
  toggleCamera: ['KeyV'],
  toggleHeadTracking: ['KeyH'],
  // Settle the view onto the wall the body just stepped onto. A head tilt does
  // the same when the camera is running; this is the camera-free route.
  swivelView: ['KeyQ'],
  // The 3D room builder's scanner. Placing is the right mouse button (the
  // grapple), so only the palette controls need keys.
  buildNext: ['KeyB'],
  buildVariant: ['KeyN'],
  buildRotate: ['KeyR'],
  buildDelete: ['KeyX'],
  buildMagnetic: ['KeyM'],
  // Direct palette keys, so the drone and its route are one press away instead
  // of a walk around the palette.
  buildDrone: ['KeyJ'],
  buildWaypoint: ['KeyK'],
  pause: ['Escape'],
  restart: ['KeyR'],
  debug: ['F3'],
};

export const MOUSE_ACTIONS: ReadonlySet<Action> = new Set<Action>(['fire', 'grapple']);
